import {SxProps} from '@mui/material';
import {COMMON_STYLES} from '../../constants/styles';
import {omit} from 'lodash';

export const STYLES = {
  ...omit(COMMON_STYLES, 'chartTitle'),
  chartTitle: {
    fontWeight: 600,
    fontSize: '14px',
    lineHeight: '17px',
    color: '#464255',
  },
  chartContainer: {
    mt: '-20px',

    '& > div': {
      minHeight: 'auto !important',
    },
  },
} as const satisfies SxProps;
